import React, { useState } from "react";
import "../styles/eventos.css";

import evento2 from "../assets/dist/img/evento2.png";
import evento1 from "../assets/dist/img/evento1.png";

const events = [
  {
    id: 1,
    title: "Tarde de Café y Poesía",
    date: "Todos los viernes",
    time: "5:00 PM",
    price: "Gratis",
    type: "Cultural",
    image: evento1,
    link: "https://forms.gle/xxxx",
    anfitrion: "Morena Mia",
    descripción:
      "Un espacio cultural semanal donde la poesía y el café se encuentran.",
  },
  {
    id: 2,
    title: "Cata de Café Especial",
    date: "Último sábado del mes",
    time: "4:00 PM",
    price: "$20.000 COP",
    type: "Experiencia",
    image: evento2,
    link: "https://forms.gle/yyyy",
    anfitrion: "Fundación Red Fibras",
    descripción:
      "Sesión de cata dirigida para explorar cafés de origen y métodos.",
  },
];

const Eventos = () => {
  const [showEventos, setShowEventos] = useState(false);

  return (
    <section id="eventos" className="eventos-section">
        <h1 className="evento-title">Proximos Eventos</h1>
      <button
        className={`menu-show-btn ${showEventos ? "active" : ""}`}
        onClick={() => setShowEventos((prev) => !prev)}
      >
        {showEventos ? "Ocultar eventos" : "Ver eventos"}
      </button>

      {/* CONTENIDO ANIMADO */}
      <div className={`toggle-content ${showEventos ? "open" : ""}`}>
        {showEventos && (
          <div className="eventos-list">
            {events.map((event) => (
              <article className="evento-card" key={event.id}>
                <img
                  src={event.image}
                  alt={event.title}
                  className="evento-img"
                />

                <div className="evento-info">
                  <span className="evento-type">{event.type}</span>
                  <h3>{event.title}</h3>

                  <ul>
                    <li><strong>Fecha:</strong> {event.date}</li>
                    <li><strong>Hora:</strong> {event.time}</li>
                    <li><strong>Precio:</strong> {event.price}</li>
                    <li><strong>Anfitrión:</strong> {event.anfitrion}</li>
                    <li><small>{event.descripción}</small></li>
                  </ul>

                  <a
                    href={event.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="evento-btn"
                  >
                    Inscribirse
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Eventos;
